import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import DriverPerformanceSearch from './DriverPerformanceSearch';

const DriverPerformance = () => {
  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <Container>
          <Header>Driver Performance</Header>
          <DriverPerformanceSearch />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverPerformance;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
`;
